exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false,"url":true,"alias":{"fonts":"..fonts"}}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5ff53514","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Loading.vue
// module id = 996
// module chunks = 1